// Add 'fixcls' class to <html> element
const htmlElement = document.documentElement;
htmlElement.classList.add('fixcls');

// Remove 'fixcls' class once the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function() {
    if (htmlElement.classList.contains('fixcls')) {
        htmlElement.classList.remove('fixcls');
    }
});